const initialState = {
  data:{},
  search:'',
  filter:[],
  sort:{
    field:'usrg_desc',
    asc:1
  }
};

export default (state = initialState, action = {}) => {
  switch(action.type) {
    case 'FETCH_USRGS':
      return {
        ...state,
        data:  action.payload
      }
    case 'SORT_USRGS':
      return {
        ...state,
        sort: action.sort
      }
    case 'SEARCH_USRGS':
      return {
        ...state,
        search: action.search
      }
    case 'EDIT_USRG':
      return {
        ...state,
        data: {
          ...state.data,
          [action.payload.usrg_id]:action.payload
        }
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/usrgs.js